define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    window.lpTag.channel = window.lpTag.channel || {};
    window.App = window.App || {};

    var PostMessageCourier = require("Chronos.PostMessageCourier");

    var _ = require('underscore');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var messagingUtils = require('web-agent-utils/MessagingUtils');

    /* ----------------------------------- [ Consts ] ----------------------------------- */
    var APPLICATION_TYPE = 'LPCoBrowseController';
    var SERVICE_UNAVAILABLE_ERROR = new Error('CoBrowse Service is unavailable.');
    var PENDING_REQUEST_ERROR = new Error('There is already a pending request');
    var ACTIVE_SESSION_ERROR = new Error('There is already a Active Sessions in progress');

    var Logger = require("logger");
    var logger = Logger.getLogger("CoBrowse");
    var STATES = {INACTIVE: 'inactive', PENDING: 'pending', ACTIVE: 'active'};
    var DIALOGSESSIONSTATES = {OPEN: 'OPEN', ACCEPTED: 'ACCEPTED', CLOSED: 'CLOSED'};
    var DIALOGSTATES = {OPEN: 'OPEN', CLOSED: 'CLOSE'};
    var ENGAGEMENTTYPES = {WEB: 'web', APP: 'app'};
    var CAPABILITIES = {COBROWSE: 'COBROWSE', VOICE_CALL: 'VOICE_CALL', VIDEO_CALL: "VIDEO_CALL"};
    var NOTIFICATION_CHANNEL_IDENTIFIER = 'lpCoBrowseController:Notification';
    var APISUPPORTS_CHANNEL_IDENTIFIER = 'lpCoBrowseController:ApiSupports';
    var SERVICE_COMMUNICATION_RETRY_INTERVAL = 60 * 1000;
    var PENDING_OFFER_CHECK_INTERVAL = 10 * 1000;
    var OFFER_TIMEOUT = 120000;
    var SERVICE_ID_DELIMITER = '#';

    var NOTIFICATION_MESSAGES_KEYS = {
        SESSION_STARTED: 'SESSION_STARTED',
        SESSION_ENDED: 'SESSION_ENDED',
        SESSION_FAILED: 'SESSION_FAILED',
        OFFER_TIMED_OUT: 'OFFER_TIMED_OUT',
        OFFER_DECLINED: 'OFFER_DECLINED',
        INVITATION_CANCELED: 'INVITATION_CANCELED'
    };

    var NOTIFICATION_MESSAGES = {
        COBROWSE: {
            SESSION_STARTED: 'engagementOrbCoBrowseSessionStarted',
            SESSION_ENDED: 'engagementOrbCoBrowseSessionEnded',
            SESSION_FAILED: 'engagementOrbCoBrowseSessionFailed',
            OFFER_TIMED_OUT: 'engagementOrbCoBrowseOfferTimeOut',
            OFFER_DECLINED: 'engagementOrbCoBrowseOfferDeclined'
        },
        CALL: {
            SESSION_STARTED: 'engagementOrbCallAccepted',
            SESSION_ENDED: 'engagementOrbCallEnded',
            OFFER_TIMED_OUT: 'engagementOrbCallMissed',
            OFFER_DECLINED: 'engagementOrbCallDeclined'
        }

    };


    /* ----------------------------------- [ Static ] ----------------------------------- */

    CoBrowseController.applicationType = APPLICATION_TYPE;
    CoBrowseController.STATES = STATES;
    CoBrowseController.NOTIFICATION_CHANNEL_IDENTIFIER = NOTIFICATION_CHANNEL_IDENTIFIER;
    CoBrowseController.NOTIFICATION_MESSAGES = NOTIFICATION_MESSAGES;

    /* ---------------------------------- [ Privates ] ---------------------------------- */

    var APP_NAME = "cobrowse";        // the application name - for the LPEvents channel
    var courier = null;              // the courier for the LPEvents transport layer
    var isCoBrowseServiceReady = false;             // indicate the service is ready for queering and commands.
    var state = STATES.INACTIVE;   // the current state of the service, initial - inactive.
    var currentVisitorId = null;              // the current visitor id engaging with the service.
    var currentTicketId = null;              // the current session ticket id, needed for revoke command.
    var currentServiceID = null;              // the current service id.
    var currentDialogID = null;              // the current service id.
    var currentMode = null;                   // the current mode, e.g. CoBrowse shared, voice, video, ...
    var currentChatId = null;
    var currentEngagementType = null;
    var model = null;              // the application model.
    var config = null;              // the configuration object.
    var pendingOfferCheckTimeoutRef = null;              // the pending check timeout reference.
    var supportedCapabilities = {};


    /* ------------------------------- [ Class Definition ] ------------------------------- */

    function CoBrowseController(applicationModel, data) {

        // setting private scope
        model = applicationModel;

        resolveConfiguration(data, onConfigReady);

        function onConfigReady(eventData) {
            config = eventData;
            initCommunicationChannel();
        }
    }

    CoBrowseController.prototype.canSendInvite = function () {
        return canSendInvite();
    };

    CoBrowseController.prototype.getSupportedCapabilities = function () {
        return supportedCapabilities;
    };

    CoBrowseController.prototype.createServiceId = function (data, callback) {
        createServiceId(data, callback);
    };

    CoBrowseController.prototype.generateServiceId = function (visitorId, chatId) {
        return visitorId + SERVICE_ID_DELIMITER + chatId;
    };


    CoBrowseController.prototype.endSession = function () {
        endSession();
    };

    /* ------------------------------ [ private functions ] ------------------------------ */

    /* ************* -- Co-Browse Interface Methods -- *************** */

    function createServiceId(data, callback) {

        // Validate the service activity
        if (!validateCommunicationChannel(data.visitorId)) {
            if (callback) {
                callback(SERVICE_UNAVAILABLE_ERROR);
            }
            return;
        }

        // Ensure that we dont have a pending session waiting.
        if (state === STATES.PENDING) {
            if (callback) {
                callback(PENDING_REQUEST_ERROR);
            }
            fireNotification({
                type: 'event',
                name: 'error',
                visitorId: data.visitorId,
                data: {
                    id: 'requestPending'
                }
            });
            return;
        }

        // ensure we don't have active sessions in progress
        if (state === STATES.ACTIVE) {
            if (callback) {
                callback(ACTIVE_SESSION_ERROR);
            }
            fireNotification({
                type: 'event',
                name: 'error',
                data: {
                    id: 'activeSessionInProgress'
                }
            });
            return;
        }

        // creating the channel
        setCurrentVisitorId(data.visitorId);
        currentEngagementType = data.engagementType;
        currentChatId = data.chatId;
        currentMode = data.mode;

        var avatarUrlPath = "userProfiles." + config.account + "." + model.get('agent.id') + ".avatarUrl";
        var avatarUrl = model.get(avatarUrlPath);

        var conversationStartTimePath = "chats." + data.chatId + ".visitorInfo.engagementStartTime";
        var conversationStartTime = model.get(conversationStartTimePath);

        // setting the state.
        setState(STATES.PENDING);

        courier.request({
            appName: APP_NAME,
            reqName: "createServiceId",
            data: {
                serviceId: data.serviceId,
                agentId: config.agentId,
                agentProfile: data.mode,
                visitorId: currentVisitorId,
                engagementType: data.engagementType,
                avatarUrl: avatarUrl,
                conversationStartTime : conversationStartTime
            }
        }, createServiceIdCallBack);

        function createServiceIdCallBack(err, response) {
            if (err) {
                setState(STATES.INACTIVE);
                logger.error('error when trying to create service id.', 'createServiceId');
                logger.graph({name: 'createServiceIdError'});
            }
            if (callback) {
                callback(err, response);
            }
            currentServiceID = data.serviceId;

            if (data.engagementType === ENGAGEMENTTYPES.APP) {

                currentDialogID = messagingUtils.generateUUID();

                var dialogMeta = {
                    "serviceId": data.serviceId,
                    "mode": data.mode,
                    "expires": (Date.now() + OFFER_TIMEOUT) / 1000,
                    "sessionState": "INVITED"
                };

                if (response && response.metaData) {
                    dialogMeta = _.extend(dialogMeta, response.metaData);
                }

                var dialog = {
                    "conversationId": data.chatId,
                    "dialogId": currentDialogID,
                    "dialog": {
                        "creationTs": Date.now(),
                        "dialogId": currentDialogID,
                        "dialogType": "OTHER",
                        "channelType": "COBROWSE",
                        "state": DIALOGSESSIONSTATES.OPEN,
                        "metaData": dialogMeta,
                        "participants": [data.visitorId, config.umsAgentId],
                        "metaDataLastUpdateTs":  Date.now()
                    }
                };

                lpTag.WebAgent.amsConnectionController.amsClient.openDialog(dialog);
            }
        }
    }

    function revokeServiceId(serviceId) {
        courier.trigger({
            appName: APP_NAME,
            eventName: "revokeOffer",
            data: {
                serviceId: serviceId
            }
        });

        fireNotification({
            type: 'event',
            name: 'revokeOffer'

        });

        setState(STATES.INACTIVE);
    }

    function endSession(message) {
        switch (state) {
            case STATES.PENDING:
                onCancelInvitation();
                revokeServiceId(currentServiceID);
                fireNotification({
                    type: 'event',
                    name: 'sessionEnded'
                });
                break;

            case STATES.ACTIVE:
                // we need to close the sessions regarding to the co-browse answer
                courier.trigger({
                    appName: APP_NAME,
                    eventName: "endSession",
                    data: currentTicketId
                });

                onSessionEndedHandler(message);
                break;
        }
    }

    function checkForPendingOffers() {
        courier.trigger({
            appName: APP_NAME,
            eventName: "checkPendingOffer",
            data: {}
        });
    }

    /* ************* -- Internal Methods -- *************** */

    function setState(newState, message) {
        if (newState !== STATES.PENDING) {
            clearPendingOfferCheck();
        }

        if (currentVisitorId) {
            var statePath = lpTag.WebAgent.logicController.getParticipantPath(currentVisitorId) + '.participantState.coBrowseSessionState';
            model.modify(statePath, newState);
        }

        // update the state.
        state = newState;

        // fire the notification anyway no matter if teh co-browse related to a participant
        fireNotification({
            type: 'stateChange',
            state: newState,
            message: message
        });
    }

    function canSendInvite() {
        return isCoBrowseServiceReady && state === STATES.INACTIVE;
    }

    function fireNotification(data) {
        // adding the visitor id, engagementType and mode to all the notifications.
        data.visitorId = data.visitorId || currentVisitorId;
        data.engagementType = currentEngagementType;
        data.mode = currentMode;

        agentLEManager.triggerLEEvent(NOTIFICATION_CHANNEL_IDENTIFIER, {
            data: data
        });
    }

    function initCommunicationChannel() {
        var pUrl = config.coBrowseBaseURL + config.communicationChannel;

        courier = new PostMessageCourier({
            target: {
                url: pUrl,
                callback: initCoBrowseService
            }
        });

        function initCoBrowseService(err) {
            if (err) {
                logger.error(err && err.toString(), 'initCoBrowseService');
                logger.graph({name: 'initCoBrowseServiceError'});
                // retry the connection in X seconds
                setTimeout(initCommunicationChannel, SERVICE_COMMUNICATION_RETRY_INTERVAL);
                return;
            }

            var initData = {
                agentName: config.agentName,
                agentId: config.agentId,
                umsAgentId: config.umsAgentID,
                site: config.account,
                coBrowseDomain: config.coBrowseDomain,
                coAppDomain: config.coAppDomain,
                coAppSettings: config.coAppSettings,
                agentAccessToken: config.agentAccessToken,
                enabledEngagements: config.enabledEngagements,
                avatarUrl: config.avatarUrl,
                handleDialog: false
            };

            courier.request({
                appName: APP_NAME,
                reqName: "init",
                data: initData
            }, function (err, data) {
                if (err) {
                    logger.error('Problem invoking request', 'initCoBrowseService:::init');
                    logger.graph({name: 'initInvokeRequestError'});
                    // retry the connection in X seconds
                    setTimeout(initCommunicationChannel, SERVICE_COMMUNICATION_RETRY_INTERVAL);
                    return;
                }

                isCoBrowseServiceReady = true;
                initBindings();
                onServiceReady();
                setState(STATES.INACTIVE);
            });
        }

        function initBindings() {
            courier.bind({
                appName: APP_NAME,
                eventName: "onVisitorAcceptsSupport",
                func: onVisitorAcceptsSupportHandler
            });

            courier.bind({
                appName: APP_NAME,
                eventName: "onVisitorDeclinesSupport",
                func: onVisitorDeclinesSupportHandler
            });

            courier.bind({
                appName: APP_NAME,
                eventName: "onSessionEnded",
                func: onSessionEndedHandler
            });

            courier.bind({
                appName: APP_NAME,
                eventName: "onError",
                func: onErrorHandler
            });

            courier.bind({
                appName: APP_NAME,
                eventName: "onVisitorJoined",
                func: onVisitorJoined
            });

            courier.bind({
                appName: APP_NAME,
                eventName: "onVisitorLeft",
                func: onVisitorLeft
            });

            courier.bind({
                appName: APP_NAME,
                eventName: "hasPendingOffer",
                func: onPendingOffer
            });

            courier.bind({
                appName: APP_NAME,
                eventName: "openWidget",
                func: onOpenWidget
            });

            courier.bind({
                appName: APP_NAME,
                eventName: "cancelInvitation",
                func: onCancelInvitation
            });

            courier.bind({
                appName: APP_NAME,
                eventName: "apiSupports",
                func: onApiSupports
            });
        }
    }

    function validateCommunicationChannel(visitorId) {
        if (!isCoBrowseServiceReady) {
            logger.error('coBrowse Api Not Ready.', 'validateCommunicationChannel');
            logger.graph({name: 'validateCommunicationChannelError'});

            fireNotification({
                type: 'event',
                name: 'error',
                visitorId: visitorId,
                data: {
                    id: 'serviceUnavailable'
                }
            });

        }
        return isCoBrowseServiceReady;
    }

    function resolveConfiguration(data, callback) {
        var coBrowseDomain = resolveCoBrowseDomain();
        var coBrowseBaseURL = resolveCoBrowseBaseURL(coBrowseDomain);
        var coAppDomain = resolveCoAppDomain();
        var coAppSettings = LE.siteSettings.cobrowseSettings.appEngagement.getSettings();
        var enabledEngagements = getEnabledEngagements();
        var agentName = null;
        var agentId = null;
        var umsAgentId = null;

        // we need to resolve this properties, they not available at application start
        model.bind('agent.agentName', onAgentNameChanged);

        function checkReady() {
            // ensure all the init data exists, stop the data binding, and fire the isReadyCallback
            var isReady = (agentName !== null && agentId !== null);

            if (isReady) {
                callback(getConfigObject());
            }
        }

        function onAgentNameChanged(eventData) {
            if (eventData && eventData.newValue) {
                agentName = eventData.newValue;
                // we are taking the agent id after the name was resolved.
                // we can't register to 'id' bind, and dirty check looking unnecessary if the data
                // is available iat this point.
                agentId = data.account + ':' + model.get('agent.id');
                umsAgentId = data.account + '.' + model.get('agent.id');

                // unbind the changes of the listener
                model.unbind('agent.agentName', onAgentNameChanged);
                checkReady();
            }
        }

        function resolveCoBrowseDomain() {
            return resolveDomain("coBrowse");
        }

        function resolveCoAppDomain() {
            return resolveDomain("coApp");
        }

        function resolveDomain(service) {
            var resolvedUrl = agentLEManager.getLEUrlResolverGetUrl({url: '{' + service + '}'});
            var urlParts = agentLEManager.getLEUrlResolverGetUrlParts(resolvedUrl);
            var domain = (urlParts && (urlParts.hostname || urlParts.host));

            // ensure that the protocol is not part of the domain
            if (domain.indexOf(':') != -1) {
                domain = domain.split(':')[0];
            }
            return domain;
        }

        function resolveCoBrowseBaseURL(domain) {
            return 'https://' + data.account + '.' + domain;
        }

        function getEnabledEngagements() {
            var coBrowseEnabled = !LE.siteSettings.cobrowseSettings.isCoBrowseDisabled();
            var coAppEnabled = LE.siteSettings.cobrowseSettings.appEngagement.isEnabled();
            return {
                web: coBrowseEnabled,
                app: coAppEnabled
            };
        }

        function getConfigObject() {
            return {
                agentId: agentId,
                umsAgentId: umsAgentId,
                agentName: agentName,
                account: data.account,
                agentAccessToken: data.accessToken,
                coBrowseDomain: coBrowseDomain,
                coBrowseBaseURL: coBrowseBaseURL,
                coAppDomain: coAppDomain,
                coAppSettings: coAppSettings,
                communicationChannel: '/webagentframe',
                enabledEngagements: enabledEngagements
            };

        }

    }

    function openCoBrowseEngagementChannel(visitorId, data) {

        var closeHandler = function (done) {
            endSession();
            if (done) {
                done();
            }
        };

        lpTag.WebAgent.logicController.openEngagementChannel(visitorId, lpTag.WebAgent.logicController.ENGAGEMENT_CHANNELS.COBROWSE, data, [lpTag.WebAgent.logicController.ENGAGEMENT_CHANNELS.CHAT], closeHandler);
    }

    function setDialogState(sessionState, dialogState) {
        dialogState = dialogState || DIALOGSTATES.OPEN;

        if (currentEngagementType === ENGAGEMENTTYPES.APP) {
            var dialog = {
                "conversationId": currentChatId,
                "dialogId": currentDialogID,
                "dialog": {
                    "dialogId": currentDialogID,
                    "dialogType": "OTHER",
                    "channelType": "COBROWSE",
                    "state": dialogState,
                    "metaData": {
                        "sessionState": sessionState
                    }
                }
            };

            lpTag.WebAgent.amsConnectionController.amsClient.updateDialog(dialog);
        }
    }

    function setCurrentVisitorId(newVisitorId) {
        // setting the lod visitor id to the new one
        var oldVisitorId = currentVisitorId;
        if (newVisitorId === currentVisitorId) {
            return;
        }
        currentVisitorId = newVisitorId;


        if (oldVisitorId !== null) {
            unbindVisitorStateEvents(oldVisitorId);
        }

        if (newVisitorId != null) {
            bindVisitorStateEvents(newVisitorId);
        }


        function bindVisitorStateEvents(visitorId) {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
            if (model.get(participantPath) == null) {
                return;
            }
            model.bind(participantPath + ".participantState.engagementState", onEngagementChangeState);
        }

        function unbindVisitorStateEvents(visitorId) {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
            model.unbind(participantPath + ".participantState.engagementState", onEngagementChangeState);
        }
    }

    /* ************** -- Events -- ************** */

    function onVisitorAcceptsSupportHandler(data) {
        // set's the current tickedId
        currentTicketId = data.ticketId;
        setCurrentVisitorId(data.visitorId || data.visitorid);
        openCoBrowseEngagementChannel(currentVisitorId, data);
        setState(STATES.ACTIVE, getNotificationMessage(NOTIFICATION_MESSAGES_KEYS.SESSION_STARTED));
        setDialogState(DIALOGSESSIONSTATES.ACCEPTED);
        fireNotification({
            type: 'event',
            name: 'visitorAccept',
            url: data.url
        });
    }

    function onVisitorDeclinesSupportHandler() {
        setState(STATES.INACTIVE, getNotificationMessage(NOTIFICATION_MESSAGES_KEYS.OFFER_DECLINED));
        setDialogState(DIALOGSESSIONSTATES.CLOSED, DIALOGSTATES.CLOSED);
        fireNotification({
            type: 'event',
            name: 'visitorDecline'
        });

        setCurrentVisitorId(null);
        currentTicketId = null;
    }

    function onSessionEndedHandler() {
        if (state === STATES.INACTIVE) {
            return;
        }

        setState(STATES.INACTIVE, getNotificationMessage(NOTIFICATION_MESSAGES_KEYS.SESSION_ENDED));
        setDialogState(DIALOGSESSIONSTATES.CLOSED, DIALOGSTATES.CLOSED);

        lpTag.WebAgent.logicController.closeEngagementChannel(currentVisitorId, lpTag.WebAgent.logicController.ENGAGEMENT_CHANNELS.COBROWSE);

        fireNotification({
            type: 'event',
            name: 'sessionEnded'
        });

        // clear the visitor info:
        setCurrentVisitorId(null);
        currentTicketId = null;
    }

    function clearPendingOfferCheck() {
        if (pendingOfferCheckTimeoutRef) {
            clearTimeout(pendingOfferCheckTimeoutRef);
        }
    }

    function onErrorHandler(err) {
        logger.warn('Received Error from CoBrowse Agent API', 'lpCoBrowseController:onErrorHandler', err);
        logger.graph({name: 'lpCoBrowseController:onErrorHandler'});

        if (err && err.id) {
            setDialogState(DIALOGSESSIONSTATES.CLOSED, DIALOGSTATES.CLOSED);

            fireNotification({
                type: 'event',
                name: 'error',
                data: err
            });

            switch (err.id) {
                case 'offerTimedOut':
                    setState(STATES.INACTIVE, getNotificationMessage(NOTIFICATION_MESSAGES_KEYS.OFFER_TIMED_OUT));
                    break;
                case 'visitorNotJoinedSession':
                    endSession('visitorNotJoinedSession');
                    break;
            }
        }

    }

    function onVisitorJoined() {
        fireNotification({
            type: 'event',
            name: 'visitorJoined'
        });
    }

    function onVisitorLeft() {
        fireNotification({
            type: 'event',
            name: 'visitorLeft'
        });
    }

    function onPendingOffer(data) {
        if (data && data.hasOwnProperty('valid')) {
            if (data.valid === true) {

                // get's the current service id from the event.
                if (data.serviceId && !currentVisitorId) {
                    currentTicketId = data.serviceId;
                    // extract the visitor id from the serviceId with the # delimiter
                    var serviceParts = data.serviceId.split(SERVICE_ID_DELIMITER);

                    // ensure the split operation success.
                    if (serviceParts && serviceParts.length) {

                        var visitorId = serviceParts[0]; // take the visitor id from the array.

                        // check the status of the conversation - if it's not active, revoke the offer.
                        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                        var chatState = model.get(participantPath + '.participantState.engagementState');

                        if (chatState !== lpTag.WebAgent.logicController.engagementStates.active) {
                            revokeServiceId(data.serviceId);
                            return;
                        } else {
                            setCurrentVisitorId(visitorId);
                            // indicate the agent that this client has a pending invite.
                            fireNotification({
                                type: 'event',
                                name: 'pendingOffer'
                            });
                        }
                    }
                }

                // re-check after 10 sec's
                pendingOfferCheckTimeoutRef = setTimeout(checkForPendingOffers, PENDING_OFFER_CHECK_INTERVAL);

                // Set the current visitor id (if any)
                setState(STATES.PENDING);
            } else if (data.valid === false) {
                // this will be true only if we successfully match the visitor id.
                // and will fire the 'offerTimedOut' event.
                if (currentVisitorId) {
                    fireNotification({
                        type: 'event',
                        name: 'error',
                        data: {id: 'offerTimedOut'}
                    });
                }

                setState(STATES.INACTIVE);
                // removing the current visitor context.
                setCurrentVisitorId(null);
            }
        }

    }

    function onOpenWidget(data) {
        if (data && data.url) {
            openCoBrowseEngagementChannel(currentVisitorId, data);
            setState(STATES.PENDING);
            fireNotification({
                type: 'event',
                name: 'openWidget'
            });
        }
    }

    function onCancelInvitation() {
        setState(STATES.INACTIVE);
        setDialogState(DIALOGSESSIONSTATES.CLOSED, DIALOGSTATES.CLOSED);
        lpTag.WebAgent.logicController.closeEngagementChannel(currentVisitorId, lpTag.WebAgent.logicController.ENGAGEMENT_CHANNELS.COBROWSE);

        fireNotification({
            type: 'event',
            name: 'invitationCanceled'
        });

        // clear the visitor info:
        setCurrentVisitorId(null);
        currentTicketId = null;
    }

    function onApiSupports(data) {
        for (var key in CAPABILITIES) {
            if (CAPABILITIES.hasOwnProperty(key)) {
                supportedCapabilities[key] = supportedCapabilities[key] || data[key];
            }
        }
        agentLEManager.triggerLEEvent(APISUPPORTS_CHANNEL_IDENTIFIER, {
            data: supportedCapabilities
        });
    }

    function onServiceReady() {
        model.bind('agent.chatsResumedCount', onChatResumed);
    }

    function onChatResumed(data) {
        model.unbind('agent.chatsResumedCount', onChatResumed);
        if (data && data.newValue !== 0) {
            checkForPendingOffers();
        }
    }

    function getNotificationMessage(key){
        if (currentMode === "VIDEO_CALL" || currentMode === "VOICE_CALL") {
            return NOTIFICATION_MESSAGES.CALL[key];
        } else {
            return NOTIFICATION_MESSAGES.COBROWSE[key];
        }
    }

    function onEngagementChangeState(data) {

        if (data && data.newValue !== lpTag.WebAgent.logicController.engagementStates.active) {
            var keyPath = data.key && data.key.split('.');
            if (keyPath && keyPath.length > 2) {

                var visitorId = keyPath[2];
                if (currentVisitorId === visitorId) {
                    // end session will call invoke the setCurrentVisitorID with null value, that will dispose the binding.
                    endSession();
                }
            }
        }
    }

    /* ******************************************** */

    return CoBrowseController;

});
